import React, {useEffect, useState} from 'react'
import MuiAppBar from '@mui/material/AppBar'
import SearchBox from './common/SearchBox/SearchBox'
import MuiToolbar from '@mui/material/Toolbar'
import styled from 'styled-components'
import CoreCleanLink from '@/components/common/CleanLink'
import Menu from '@/components/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import {Drawer, IconButton, List, ListItemButton} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Link from '@/components/common/Link'
import {useLocation} from 'react-router-dom'
import {ROUTES} from '@/utils/routes'
import {useSelector} from 'react-redux'
import {InitialStateType} from '@/store/reducers'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'


const AppBar = styled(MuiAppBar)`
    min-height: 72px;
    background: ${ThemeColorsHospitalic.PRIMARY};

    .MuiToolbar-root {
        min-height: 72px;
    }
`

const Toolbar = styled(MuiToolbar)`
    position: relative;
    min-width: 100%;
    justify-content: space-between;
    height: 0.00001em; // weird height vs min-height thing
`

const CleanLink = styled(CoreCleanLink)`
    display: flex;
    position: relative;
    z-index: 10;
    align-items: center;
`

const LeftNavWrapper = styled.div`
    display: flex;
    height: 100%;
`

const HamburgerIcon = styled(MenuIcon)``

export default function MenuAppBar() {
    const theme = useTheme()
    const location = useLocation()
    const matches = useMediaQuery(theme.breakpoints.down('md'))
    const [drawerOpen, setDrawerOpen] = useState(false)

    const {type} = useSelector((state: InitialStateType) => state.user)

    const onDrawerOpen = () => {
        setDrawerOpen(true)
    }

    const onDrawerClose = () => {
        setDrawerOpen(false)
    }

    useEffect(() => {
        if (drawerOpen) {
            setDrawerOpen(false)
        }
    }, [location])

    return (
        <AppBar position='relative' elevation={0}>
            <Toolbar>
                <LeftNavWrapper>
                    <CleanLink to='/'>
                        <Typography fontWeight='bold' marginLeft='30px' marginRight='30px'>
                            Czech digiTAl Genome
                        </Typography>
                    </CleanLink>
                    {!matches && <Menu />}
                </LeftNavWrapper>
                {matches &&
                    <>
                        <IconButton
                            onClick={onDrawerOpen}
                            edge='start'
                            color='inherit'
                        >
                            <HamburgerIcon/>
                        </IconButton>
                        <Drawer
                            anchor='right'
                            open={drawerOpen}
                            onClose={onDrawerClose}
                        >
                            <List>
                                <ListItem
                                    disablePadding
                                    component={Link}
                                    to={ROUTES.HOME}
                                >
                                    <ListItemButton>
                                        <ListItemText primary='Home'/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem
                                    disablePadding
                                    component={Link}
                                    to={ROUTES.DATA_INFO}
                                >
                                    <ListItemButton>
                                        <ListItemText primary='Data info'/>
                                    </ListItemButton>
                                </ListItem>
                                {type === 'user' && <ListItem
                                    disablePadding
                                    component={Link}
                                    to={ROUTES.JOBS_DATASET}
                                >
                                    <ListItemButton>
                                        <ListItemText primary='Jobs'/>
                                    </ListItemButton>
                                </ListItem>}
                            </List>
                        </Drawer>
                    </>}
                <Box display='flex' alignItems='center'>
                    {!matches && <SearchBox />}
                    {/* <AccountMenu/>*/}
                </Box>
            </Toolbar>
        </AppBar>
    )
}
